import './i18n';
import './App.css';
import NavBar from './components/Navbar';
import Conocenos from './components/Conocenos';
// import Conocenos2 from './components/Conocenos2'
// import Productos from './components/Productos'
// import Servicios from './components/Servicios'
import Sumate from './components/Sumate';
import Novedades from './components/Novedades';
import Quienes from './components/Quienes';
import Footer from './components/Footer';
import Clientes from './components/Clientes';
import Capacidades from './components/Capacidades';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Backoffice from './components/Backoffice';
import LogIn from './components/LogIn';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route
					path='/'
					element={
						<Container className='containerMain'>
							<NavBar />
							<Conocenos />
							{/* <Productos/> */}
							{/* <Servicios /> */}
							<Capacidades />
							<Clientes />
							<Sumate />
							<Novedades />
							<Quienes />
							<Footer />
						</Container>
					}
				/>
				<Route path='/backoffice' element={<Backoffice />} />
				<Route path='/login' element={<LogIn />} />
				<Route path='*' element={<Navigate replace to='/' />} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;
